<template>
    <div id="container" type="vmortgages">
        <div class="page page-mortgages" v-ga:request="{pageType:'vmortgages', state: {}}" v-ga:page="{pageType:'vmortgages', glb: glb, state: {}}">
            <mvtHeader />
            <section class="mortage-hero inline large bg-white fixed fixed-max-sm">
                <h1 class="f0 text-bold text-center">Looking for a mortgage loan? <br> Let Movoto help you.</h1>
                <p class="f4 text-center">See your live personalized rates in under 1 minute. It's 100% free and you'll be prepared to write an offer on a home.</p>
                <form v-submit.prevent="popDialog">
                    <mvtTextbox>
                        <div class="input">
                            <label>ZIP Code</label>
                            <input ref="zipcode" type="text" name="zipcode" v-model="zipcode" v-validate="'required|zipcode'" maxlength="5" />
                        </div>
                    </mvtTextbox>
                    <button class="btn primary regular" type="submit">{{ ctaText }}</button>
                </form>
            </section>

            <mortgageTools class="mortgage-tools" title="Explore mortgage tools" subText="Not sure where to start? Movoto can help."></mortgageTools>

            <section class="inline large bg-white">
                <mvtLazyload>
                    <mvtRateTrend></mvtRateTrend>
                </mvtLazyload>
            </section>

            <section class="inline large">
                <mvtArticleGrid :limit="6" :tag="['mortgage']" />
            </section>

            <section class="inline large bg-white" v-if="getShowList('location')" style="padding-bottom:0">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <div class="text-center">
                        <h2 class="f3 text-bold">Nearby homes for sale</h2>
                    </div>
                    <mvtLazyload ref="lazyloadNearby" :async="true" data-role="propertycard">
                        <mvtNearby type="location" @completed="completed" carousalType="for_sale"></mvtNearby>
                    </mvtLazyload>
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-mortgages.js"></script>

<style lang="scss">
    @use './page-mortgages.scss' as *;
</style>